import MemberValue from './MemberValue';
import './style/index.less';

export default MemberValue;
